function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import axios from 'axios';
import is from 'is';
import ExpiredStorage from 'expired-storage';
var expiredStorage = new ExpiredStorage();
var EXPIRESTIME = 60 * 20;

var ApiManager = /*#__PURE__*/function () {
  function ApiManager() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ApiManager);

    this.$apiUrl = config.urls.api || "".concat(window.location.pathname, "/api/v2");
    this.$root = config.urls.root;
    this.token = expiredStorage.getItem('user');
    this.$curFID = 0;
    this.$curEID = 0;
    this.$curProcessId = null;
    this.$boolEnvProd = false;
    this.cliente = {};
    this.permission = true;
    this.paymentChannel = null;
    this.apiRedirectTo = config.redirectTo || '/';
    var ppid = window.localStorage.getItem('p_pid');

    if (!ppid) {
      window.localStorage.setItem('p_pid', '[]');
    } else {
      this.ppid = JSON.parse(ppid);
    }
  }

  _createClass(ApiManager, [{
    key: "getEspectaculoCartelTipos",
    value: function getEspectaculoCartelTipos() {
      var path = "".concat(this.$apiUrl, "/EspectaculoCartelTipos");
      var config = {
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;
      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "getEspectaculosCartel",
    value: function getEspectaculosCartel(params) {
      var _this = this;

      var path = "".concat(this.$apiUrl, "/EspectaculosCartel");
      var config = {
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (params) {
        config['params'] = params;
        config['headers']['Content-Type'] = 'application/json';
      }

      var ppid = window.localStorage.getItem('p_pid');

      if (!ppid) {
        window.localStorage.setItem('p_pid', '[]');
      } else {
        this.ppid = JSON.parse(ppid);
        var list = [];

        if (this.ppid.length) {
          this.ppid.forEach(function (p) {
            list.push(_this.setProcessInvalidar(p));
          });
        }

        Promise.all(list).then(function () {
          window.localStorage.setItem('p_pid', '[]');
          _this.ppid = [];
          list = [];
        });
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "getEspectaculoCartel",
    value: function getEspectaculoCartel(id, query) {
      var _this2 = this;

      var path = "".concat(this.$apiUrl, "/EspectaculoCartel/").concat(id);

      if (query) {
        path = "".concat(this.$apiUrl, "/EspectaculoCartel/").concat(id).concat(query);
      }

      var config = {
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;
      var ppid = window.localStorage.getItem('p_pid');

      if (!ppid) {
        window.localStorage.setItem('p_pid', '[]');
      } else {
        this.ppid = JSON.parse(ppid);
        var list = [];

        if (this.ppid.length) {
          this.ppid.forEach(function (p) {
            list.push(_this2.setProcessInvalidar(p));
          });
        }

        Promise.all(list).then(function () {
          window.localStorage.setItem('p_pid', '[]');
          _this2.ppid = [];
          list = [];
        });
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "getEspectaculo",
    value: function getEspectaculo(id) {
      var _this3 = this;

      var path = "".concat(this.$apiUrl, "/Espectaculo/").concat(id);
      var config = {
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      };
      var ppid = window.localStorage.getItem('p_pid');

      if (!ppid) {
        window.localStorage.setItem('p_pid', '[]');
      } else {
        this.ppid = JSON.parse(ppid);
        var list = [];

        if (this.ppid.length) {
          this.ppid.forEach(function (p) {
            list.push(_this3.setProcessInvalidar(p));
          });
        }

        Promise.all(list).then(function () {
          window.localStorage.setItem('p_pid', '[]');
          _this3.ppid = [];
          list = [];
        });
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            _this3.$curEID = id;
            resolve(response.data);
          } else {
            _this3.$curEID = 0;
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "getFuncion",
    value: function getFuncion(id, query) {
      var _this4 = this;

      this.$curFID = id;
      this.$curNFID = id;

      if (query.length > 0) {
        this.$curFID = "".concat(id).concat(query);
      }

      var path = "".concat(this.$apiUrl, "/Funcion/").concat(id);

      if (query) {
        path = "".concat(this.$apiUrl, "/Funcion/").concat(id).concat(query);
      }

      var config = {
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      };
      var ppid = window.localStorage.getItem('p_pid');

      if (!ppid) {
        window.localStorage.setItem('p_pid', '[]');
      } else {
        this.ppid = JSON.parse(ppid);
        var list = [];

        if (this.ppid.length) {
          this.ppid.forEach(function (p) {
            list.push(_this4.setProcessInvalidar(p));
          });
        }

        Promise.all(list).then(function () {
          window.localStorage.setItem('p_pid', '[]');
          _this4.ppid = [];
          list = [];
        });
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "getPromocionFuncion",
    value: function getPromocionFuncion(id, params) {
      if (!params || !is.object(params)) {
        throw new Error("\"params\" no esta definido o no es un objeto");
      } // console.log(params)


      var path = "".concat(this.$apiUrl, "/Funcion/").concat(id, "/Promociones");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "getProcess",
    value: function getProcess(id) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!id) {
        id = this.$curProcessId;
      }

      var path = "".concat(this.$apiUrl, "/Proceso/").concat(id);
      var config = {
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "getProcessTiposDeEntrega",
    value: function getProcessTiposDeEntrega(id) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!id) {
        id = this.$curProcessId;
      }

      var path = "".concat(this.$apiUrl, "/Proceso/").concat(id, "/TiposDeEntrega");
      var config = {
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "getProcessFormasDePago",
    value: function getProcessFormasDePago(id) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!id) {
        id = this.$curProcessId;
      }

      var path = "".concat(this.$apiUrl, "/Proceso/").concat(id, "/FormasDePago");
      var config = {
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "getProcessTarjetasFormasDePago",
    value: function getProcessTarjetasFormasDePago() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var path = "".concat(this.$apiUrl, "/Proceso/").concat(this.$curProcessId, "/FormaDePago/").concat(params.type, "/Tarjetas/").concat(params.bin);
      var config = {
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "getProcessEstados",
    value: function getProcessEstados() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var path = "".concat(this.$apiUrl, "/Proceso/").concat(this.$curProcessId, "/PosicionesEstado/").concat(params.idSector);
      var config = {
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "setProcessCerrar",
    value: function setProcessCerrar() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var path = "".concat(this.$apiUrl, "/Proceso/").concat(this.$curProcessId, "/Cerrar");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "setProcessInvalidar",
    value: function setProcessInvalidar(p) {
      var _this5 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var path = "".concat(this.$apiUrl, "/Proceso/").concat(this.$curProcessId ? this.$curProcessId : p, "/Invalidar");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            if (response.data) {
              _this5.ppid = _this5.ppid.filter(function (item) {
                return item !== response.data.oData.idProcesoDeCompra;
              });
              window.localStorage.setItem('p_pid', JSON.stringify(_this5.ppid));
            }

            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "setProcessCobrar",
    value: function setProcessCobrar() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var path = "".concat(this.$apiUrl, "/Proceso/").concat(this.$curProcessId, "/Cobrar");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      window.localStorage.setItem('p_pid', '[]');
      this.ppid = [];
      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "setProcessConfirmacion",
    value: function setProcessConfirmacion() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var path = "".concat(this.$apiUrl, "/Proceso/").concat(this.$curProcessId);
      var config = {
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "setPosicionesTomar",
    value: function setPosicionesTomar(params) {
      var _this6 = this;

      if (!params || !is.object(params)) {
        throw new Error("\"params\" no esta definido o no es un objeto");
      }

      var processId = params.idProcesoDeCompra !== '' ? params.idProcesoDeCompra : 0;
      var path = "".concat(this.$apiUrl, "/Proceso/").concat(processId, "/Posiciones/Tomar");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };

      if (!params['idFuncion']) {
        params['idFuncion'] = this.$curNFID;
      }

      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            _this6.$curProcessId = response.data.oData.idProcesoDeCompra;

            if (_this6.ppid) {
              if (_this6.ppid.indexOf(_this6.$curProcessId) === -1) {
                _this6.ppid.push(_this6.$curProcessId);

                window.localStorage.setItem('p_pid', JSON.stringify(_this6.ppid));
              }
            }

            resolve(response.data);
          }
        }).catch(function (err) {
          console.log(err);
          reject(err);
        });
      });
    }
  }, {
    key: "setPosicionesSoltar",
    value: function setPosicionesSoltar(params) {
      if (!params || !is.object(params)) {
        throw new Error("\"params\" no esta definido o no es un objeto");
      }

      if (!params['idFuncion']) {
        params['idFuncion'] = parseInt(this.$curNFID);
      }

      var processId = params.idProcesoDeCompra || 0;
      var path = "".concat(this.$apiUrl, "/Proceso/").concat(processId, "/Posiciones/Soltar");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "getPosicionesMapa",
    value: function getPosicionesMapa(params) {
      if (!params || !is.object(params)) {
        throw new Error("\"params\" no esta definido o no es un objeto");
      }

      if (!params['idFuncion']) {
        params['idFuncion'] = this.$curNFID;
      }

      var processId = params.idProcesoDeCompra || 0;
      var path = "".concat(this.$apiUrl, "/Proceso/").concat(processId, "/Posiciones");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    } // registerNewUser (params) {
    //   if (!params || !is.object(params)) {
    //     throw new Error(`"params" no esta definido o no es un objeto`)
    //   }
    //
    //   let path = `${this.$apiUrl}/Cliente/Registrar`
    //   let config = {
    //     method: 'POST',
    //     headers: {
    //       'Access-Control-Allow-Origin': '*'
    //     },
    //     data: params
    //   }
    //
    //   let domicilio = {
    //     idPais: 10,
    //     idProvincia: 0,
    //     idLocalidad: 0,
    //     bDefault: true
    //   }
    //
    //   Object.assign(domicilio, params)
    //
    //   return new Promise((resolve, reject) => {
    //     axios(path, config).then((response) => {
    //       if (response.data) {
    //         resolve(response.data)
    //       }
    //     })
    //       .catch(function (err) {
    //         reject(err)
    //       })
    //   })
    // }

  }, {
    key: "registerNewUser",
    value: function registerNewUser(params) {
      if (!params || !is.object(params)) {
        throw new Error("\"params\" no esta definido o no es un objeto");
      }

      var path = "".concat(this.$apiUrl, "/Cliente/Insertar");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    } // loginUser (params) {
    //   if (!params || !is.object(params)) {
    //     throw new Error(`"params" no esta definido o no es un objeto`)
    //   }
    //
    //   let path = `${this.$apiUrl}/Cliente/Ingreso`
    //   // let path = `${this.$apiUrl}/Login`
    //   let config = {
    //     method: 'POST',
    //     headers: {
    //       'Access-Control-Allow-Origin': '*'
    //     },
    //     data: params
    //   }
    //
    //   window.localStorage.removeItem('client')
    //
    //   return new Promise((resolve, reject) => {
    //     axios(path, config).then((response) => {
    //       if (response.data && response.data.oCliente !== null) {
    //         let tt = response.data.token
    //
    //         this.token = tt
    //
    //         expiredStorage.setItem('user', tt, EXPIRESTIME)
    //
    //         if (tt) {
    //           window.localStorage.setItem('client', response.data.oCliente)
    //         }
    //
    //         this.logued = true
    //
    //         resolve(response.data)
    //       } else {
    //         resolve({})
    //       }
    //     })
    //       .catch(function (err) {
    //         reject(err)
    //       })
    //   })
    // }

  }, {
    key: "loginUser",
    value: function loginUser(params) {
      var _this7 = this;

      if (!params || !is.object(params)) {
        throw new Error("\"params\" no esta definido o no es un objeto");
      }

      var path = "".concat(this.$apiUrl, "/Cliente/Ingreso/Token"); // let path = `${this.$apiUrl}/Login`

      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      window.localStorage.removeItem('client');
      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data && response.data.oCliente !== null) {
            var tt = response.data.token;
            _this7.token = tt;
            expiredStorage.setItem('user', tt, EXPIRESTIME);

            if (tt) {
              window.localStorage.setItem('client', response.data.oCliente);
            }

            _this7.logued = true;
            resolve(response.data);
          } else {
            resolve({});
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "loginStatus",
    value: function loginStatus() {
      var _this8 = this;

      var path = "".concat(this.$apiUrl, "/Logueado");
      var config = {
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json'
        }
      };

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve) {
        axios(path, config).then(function (cliente) {
          // console.log(cliente.data)
          if (cliente.data.oCliente) {
            resolve(cliente.data);
          } else {
            resolve(cliente.data);
          }
        }).catch(function (err) {
          _this8.token = expiredStorage.getItem('user');
          resolve({});
        });
      });
    }
  }, {
    key: "logout",
    value: function logout() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var path = "".concat(this.$apiUrl, "/Salir"); // console.info(path)

      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          window.localStorage.removeItem('ga_id_t');
          window.localStorage.removeItem('ga_id');
          window.localStorage.removeItem('user');
          resolve(response);
        }).catch(function (err) {
          window.localStorage.removeItem('ga_id_t');
          window.localStorage.removeItem('ga_id');
          reject(err);
        });
      });
    }
  }, {
    key: "getCliente",
    value: function getCliente() {
      var _this9 = this;

      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var path = "".concat(this.$apiUrl, "/Cliente");
      var config = {
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            _this9.clientInformacion = response.data;
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "getClienteInfomacion",
    value: function getClienteInfomacion() {
      var _this10 = this;

      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var path = "".concat(this.$apiUrl, "/Cliente/Informacion");
      var config = {
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            _this10.clientInformacion = response.data;
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    } // setCliente (params = {}) {
    //   let path = `${this.$apiUrl}/Cliente/Modificar`
    //   let config = {
    //     method: 'POST',
    //     headers: {
    //       'Access-Control-Allow-Origin': '*'
    //     },
    //     data: params
    //   }
    //
    //   config['credentials'] = window.origin
    //   config['crossDomain'] = true
    //
    //   if (this.token) {
    //     config.headers['Authorization'] = `Bearer ${this.token}`
    //   }
    //
    //
    //   return new Promise((resolve, reject) => {
    //     axios(path, config).then((response) => {
    //       if (response.data) {
    //         resolve(response.data)
    //       }
    //     })
    //       .catch(function (err) {
    //         reject(err)
    //       })
    //   })
    // }

  }, {
    key: "setCliente",
    value: function setCliente() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var path = "".concat(this.$apiUrl, "/Cliente/Modificar/DatosPersonales");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "setClienteDomicilio",
    value: function setClienteDomicilio() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var path = "".concat(this.$apiUrl, "/Cliente/Domicilio/Insertar");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "setClienteDomicilioCambio",
    value: function setClienteDomicilioCambio(idClienteDomicilio) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var path = "".concat(this.$apiUrl, "/Cliente/Domicilio/").concat(idClienteDomicilio, "/Modificar");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "setClienteDomicilioEliminar",
    value: function setClienteDomicilioEliminar(idClienteDomicilio) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var path = "".concat(this.$apiUrl, "/Cliente/Domicilio/").concat(idClienteDomicilio, "/Eliminar");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "setClienteTelefono",
    value: function setClienteTelefono() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var path = "".concat(this.$apiUrl, "/Cliente/Telefono/Insertar");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "setClienteTelefonoCambio",
    value: function setClienteTelefonoCambio(idClienteTelefono) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var path = "".concat(this.$apiUrl, "/Cliente/Telefono/").concat(idClienteTelefono, "/Modificar");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "setClienteTelefonoEliminar",
    value: function setClienteTelefonoEliminar(idClienteTelefono) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var path = "".concat(this.$apiUrl, "/Cliente/Telefono/").concat(idClienteTelefono, "/Eliminar");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    } // setClaveCliente (params = {}) {
    //   let path = `${this.$apiUrl}/Cliente/ModificarClave`
    //   let config = {
    //     method: 'POST',
    //     headers: {
    //       'Access-Control-Allow-Origin': '*'
    //     },
    //     data: params
    //   }
    //
    //   config['credentials'] = window.origin
    //   config['crossDomain'] = true
    //
    //   if (this.token) {
    //     config.headers['Authorization'] = `Bearer ${this.token}`
    //   }
    //
    //
    //   return new Promise((resolve, reject) => {
    //     axios(path, config).then((response) => {
    //       if (response.data) {
    //         resolve(response.data)
    //       }
    //     })
    //       .catch(function (err) {
    //         reject(err)
    //       })
    //   })
    // }

  }, {
    key: "setClaveCliente",
    value: function setClaveCliente() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var path = "".concat(this.$apiUrl, "/Cliente/Modificar/Clave");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "getHistory",
    value: function getHistory() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var path = "".concat(this.$apiUrl, "/Historial2"); // let path = `${this.$apiUrl}/Historial`

      var config = {
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "setNewsletter",
    value: function setNewsletter(params) {
      var path = "".concat(this.$apiUrl, "/NewsLetter/Suscripcion");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "setClaveBlanqueo",
    value: function setClaveBlanqueo(params) {
      var path = "".concat(this.$apiUrl, "/Cliente/RecuperoClave");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "setContactoMensaje",
    value: function setContactoMensaje(params) {
      var path = "".concat(this.$apiUrl, "/Contacto");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "getProductoAsignado",
    value: function getProductoAsignado(id) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!id) {
        id = this.$curProcessId;
      }

      var path = "".concat(this.$apiUrl, "/Proceso/").concat(id, "/ProductoAsignado/Lista/Obtener");
      var config = {
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "setProductoAsignado",
    value: function setProductoAsignado(id) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!id) {
        id = this.$curProcessId;
      }

      var path = "".concat(this.$apiUrl, "/Proceso/").concat(id, "/ProductoAsignado/Lista/Seleccionar");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "setEntregaTipoSeleccionar",
    value: function setEntregaTipoSeleccionar(id) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!id) {
        id = this.$curProcessId;
      }

      var path = "".concat(this.$apiUrl, "/Proceso/").concat(id, "/EntregaTipo/Seleccionar");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "setFormaDePagoTipoSeleccionar",
    value: function setFormaDePagoTipoSeleccionar(id) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!id) {
        id = this.$curProcessId;
      }

      var path = "".concat(this.$apiUrl, "/Proceso/").concat(id, "/FormaDePago/Seleccionar");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    } // nuevos servicios de recupero de clave

  }, {
    key: "clienteCodigoRecupero",
    value: function clienteCodigoRecupero(params) {
      var path = "".concat(this.$apiUrl, "/Cliente/CodigoRecupero");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "clienteClaveCodigoCambio",
    value: function clienteClaveCodigoCambio(params) {
      var path = "".concat(this.$apiUrl, "/Cliente/ModificarClave/CodigoRecupero");
      var config = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        data: params
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (this.token) {
        config.headers['Authorization'] = "Bearer ".concat(this.token);
      }

      return new Promise(function (resolve, reject) {
        axios(path, config).then(function (response) {
          if (response.data) {
            resolve(response.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "load",
    value: function load(url) {
      var async = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var cb = arguments.length > 2 ? arguments[2] : undefined;
      var done = false;
      var script = document.createElement('script'); // console.info(url);

      script.src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'EU_SDK=' + Math.random() * Math.random();
      script.async = async;

      script.onload = script.onreadystatechange = function () {
        if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
          done = true;
          cb && cb();
          script.onload = script.onreadystatechange = null;

          if (script && script.parentNode) {
            script.parentNode.removeChild(script);
          }
        }
      };

      script.onerror = function () {
        console.info('error');
      };

      document.getElementsByTagName('head')[0].appendChild(script);
    }
  }]);

  return ApiManager;
}();

export { ApiManager as default };